<template>
  <div>
    <h2 style="text-align: center; padding: 10px 0">
      Регистрация оператора вывоза отходов
    </h2>
    <container>
      <v-stepper v-model="step" vertical non-linear flat>
        <!-- STEP 1 -->
        <v-stepper-step
          step="1"
          :complete="step > 1"
          :color="step > 1 ? 'green' : 'primary'"
          alt-labels
          :editable="editable"
        >
          Тип учётной записи
          <b>{{ accountTypes[accountType] }}</b>
        </v-stepper-step>
        <v-stepper-content step="1">
          <div class="ma-2">
            <v-radio-group
              v-model="accountType"
              mandatory
              :row="$vuetify.breakpoint.xlOnly"
            >
              <v-radio
                v-for="(n, at) in accountTypes"
                :key="at.id"
                :label="n"
                :value="at"
              ></v-radio>
            </v-radio-group>
            <v-btn color="primary" @click="next">Далее</v-btn>
          </div>
        </v-stepper-content>

        <!-- STEP 2 -->
        <v-stepper-step
          step="2"
          :complete="step > 2"
          :color="step > 2 ? 'green' : 'primary'"
          alt-labels
          :editable="editable"
        >
          Заполнение реквизитов
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="ma-2">
            <v-radio-group
              v-if="debug"
              v-model="accountType"
              mandatory
              :row="$vuetify.breakpoint.xlOnly"
            >
              <v-radio
                v-for="(n, at) in accountTypes"
                :key="at.id"
                :label="n"
                :value="at"
              ></v-radio>
            </v-radio-group>
          </div>
          <v-form ref="form" v-model="form.valid" @submit.prevent>
            <div class="ma-2">
              <!-- <div v-if="accountType == 'u'"></div> -->
              <field-set title="Реквизиты" color="rgba(0 0 0/0.12)">
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.inn"
                      v-required
                      label="ИНН"
                      :rules="rule_required"
                      prepend-inner-icon="mdi-magnify"
                      :loading="search.inn.loading"
                      @input="fillForm"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.data.ogrn"
                      v-required
                      label="ОГРН"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-if="accountType == 'u'"
                      v-model="form.data.kpp"
                      v-required
                      label="КПП"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </field-set>

              <field-set
                :title="accountType == 'u' ? 'Организация' : 'Предприниматель'"
                color="rgba(0 0 0/0.12)"
              >
                <v-text-field
                  v-model="form.data.name"
                  v-required
                  :label="
                    accountType == 'u' ? 'Название' : 'Полное наименование'
                  "
                  :rules="rule_required"
                ></v-text-field>
                <v-text-field
                  v-model="form.data.short_name"
                  v-required
                  :label="
                    accountType == 'u'
                      ? 'Короткое название'
                      : 'Краткое наименование'
                  "
                  :rules="rule_required"
                ></v-text-field>
              </field-set>

              <field-set title="Адрес офиса" color="rgba(0 0 0/0.12)">
                <v-row dense>
                  <v-col>
                    <v-autocomplete
                      v-model="form.data.city_nmbr"
                      v-required
                      label="Населенный пункт"
                      :loading="search.city.loading"
                      :items="search.city.items"
                      :search-input.sync="search.city.text"
                      hide-no-data
                      auto-select-first
                      item-text="name"
                      item-value="nmbr"
                      :rules="rule_required"
                      @input="setDefaultArea"
                    ></v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="form.data.street_nmbr"
                      v-required
                      label="Улица"
                      :loading="search.street.loading"
                      :items="search.street.items"
                      :search-input.sync="search.street.text"
                      cache-items
                      hide-no-data
                      auto-select-first
                      item-text="name"
                      item-value="nmbr"
                      :rules="rule_required"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.house"
                      v-required
                      label="Дом"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.data.flat"
                      label="Помещение"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </field-set>

              <field-set
                title="Обратная связь с заказчиками"
                color="rgba(0 0 0/0.12)"
              >
                <v-text-field
                  v-model="form.data.website"
                  label="Сайт"
                ></v-text-field>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.pub_email"
                      v-required
                      label="Email"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.data.pub_mobile"
                      v-required
                      label="Телефон"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </field-set>

              <field-set
                v-required
                title="Область вывоза мусора"
                color="rgba(0 0 0/0.12)"
              >
                <v-row dense>
                  <v-col align-self="center" justify-self="center">
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          outlined
                          depressed
                          tile
                          style="border-color: rgba(0 0 0 / 0.12)"
                          v-on="on"
                          @click="editPolygon"
                        >
                          <span v-html="poly_svg"></span>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <span class="ml-2">Нарисовать область на карте</span>
                      </template>
                      <span>Редактировать область</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="form.data.area_nmbr"
                      v-required="!form.data.points?.length"
                      :value="form.data.city_nmbr"
                      label="Населенный пункт"
                      :loading="search.area.loading"
                      :items="search.area.items"
                      :search-input.sync="search.area.text"
                      hide-no-data
                      auto-select-first
                      item-text="name"
                      item-value="nmbr"
                      :rules="!form.data.points?.length ? rule_required : []"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" align="center">
                    Заполните хотя бы одно поле
                  </v-col>
                </v-row>
              </field-set>

              <field-set
                v-if="accountType == 'u'"
                title="Руководитель"
                color="rgba(0 0 0/0.12)"
              >
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.manager_fio"
                      v-required
                      label="ФИО"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-autocomplete
                      v-model="form.data.manager_post_nmbr"
                      v-required
                      label="Должность"
                      :loading="search.post.loading"
                      :items="search.post.items"
                      :search-input.sync="search.post.text"
                      cache-items
                      hide-no-data
                      auto-select-first
                      item-text="name"
                      item-value="nmbr"
                      :rules="rule_required"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.mobile"
                      v-required
                      label="Сотовый телефон"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.data.email"
                      v-required
                      label="E-mail"
                      :rules="[rule_required[0], rule_email[0]]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </field-set>
              <field-set
                v-else
                title="Для регистрации в сервисе"
                color="rgba(0 0 0/0.12)"
              >
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="form.data.email"
                      v-required
                      label="E-mail"
                      :rules="[rule_required[0], rule_email[0]]"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="form.data.mobile"
                      v-required
                      label="Сотовый телефон"
                      :rules="rule_required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </field-set>
              <v-row><v-col></v-col></v-row>
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    color="primary"
                    :disabled="!formValid"
                    :loading="loading"
                    @click="register"
                  >
                    <v-icon>mdi-lock</v-icon>
                    Регистрация
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-stepper-content>

        <!-- STEP 3 -->
        <v-stepper-step
          step="3"
          :complete="step > 3"
          :color="step > 3 ? 'green' : 'primary'"
          alt-labels
          :editable="editable"
        >
          Подтверждение телефона
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-form v-model="form.verify_valid" class="ma-2" @submit.prevent>
            <v-row>
              <v-col cols="12" style="font-size: large">
                <!-- На Ваш телефон
                <strong>{{ form.data.mobile }}</strong>
                совершён звонок. 4 последные цифры номера входящего звонка
                являются кодом подтверждения, который нужно ввести ниже. -->

                На Ваш телефон
                <strong>{{ form.data.mobile }}</strong>
                совершён звонок. Голосом будет сообщён четырёхзначный код
                подтверждения, который нужно ввести ниже.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3"></v-col>
              <v-col>
                <v-otp-input
                  v-model="sms_code"
                  :length="4"
                  prepend-inner-icon="mdi-android-messages"
                  dense
                  :rules="rule_required"
                ></v-otp-input>
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <v-row v-if="false">
              <v-col cols="12" md="6">
                <v-text-field
                  label="Сотовый телефон"
                  prepend-inner-icon="mdi-phone"
                  :value="form.data.mobile"
                  readonly
                  dense
                >
                  <template v-if="form.phone_verifyed" #append>
                    <v-icon color="green">mdi-check</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="sms_code"
                  v-required
                  label="Код подтверждения"
                  prepend-inner-icon="mdi-android-messages"
                  dense
                  :rules="rule_required"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <template v-if="form.timer.counting">
                <vue-countdown
                  ref="countdown"
                  :time="90000"
                  :auto-start="false"
                  @start="form.timer.counting = true"
                  @end="form.timer.counting = false"
                >
                  <template #default="{ minutes, seconds }">
                    <span style="font-size: large">
                      Отправить СМС через
                      {{ minutes.toString().padStart(2, "0") }}:{{
                        seconds.toString().padStart(2, "0")
                      }}
                    </span>
                  </template>
                </vue-countdown>
              </template>
              <template v-else>
                <v-btn :disabled="form.timer.counting" @click="get_code('0')">
                  Отправить СМС
                </v-btn>
              </template>
            </v-row>
            <v-row>
              <v-col class="d-flex justify-center">
                <v-btn
                  :block="$vuetify.breakpoint.smAndDown"
                  color="primary"
                  :loading="loading"
                  :disabled="!form.verify_valid || sms_code.length != 4"
                  @click="verify_phone"
                >
                  <v-icon>mdi-lock</v-icon>
                  Завершить регистрацию
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>

        <!-- STEP 4 -->
        <v-stepper-step
          step="4"
          :complete="step >= 4"
          :color="step >= 4 ? 'green' : 'primary'"
          alt-labels
          :editable="editable"
        >
          Регистрация завершена
        </v-stepper-step>
        <v-stepper-content step="4">
          <div class="ma-2">
            <v-container>
              <v-row>
                <v-col>
                  Для того, чтобы сейчас войти в личный кабинет, нажмите кнопку
                  "Войти". Вы также можете войти в личный кабинет введя логин и
                  пароль из письма на странице
                  <v-icon>mdi-location-enter</v-icon>
                  <router-link to="/login">входа</router-link>
                </v-col>
              </v-row>
              <v-row v-if="user_data.login && user_data.password">
                <v-col>
                  <v-btn @click="do_login">Войти</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-stepper-content>
      </v-stepper>
    </container>

    <!-- <container>
      <template v-slot:title>Регистрация</template>

      <template v-slot:actions>
        <v-btn
          color="info"
          :large="$vuetify.breakpoint.smAndUp"
          :disabled="!form.valid"
          @click="register"
        >
          <v-icon left>mdi-lock</v-icon>
          {{ buttonText }}
        </v-btn>
      </template>

      <v-form ref="form" v-model="form.valid" @submit.prevent>
        <v-radio-group v-model="accountType" mandatory>
          <v-radio
            v-for="(n, at) in accountTypes"
            :key="at.id"
            :label="n"
            :value="at"
          ></v-radio>
        </v-radio-group>

        <v-card class="pa-3 ma-1">
          <div v-if="accountType == 'individual'">
            <v-text-field
              v-required
              label="Обращение"
              :value="individual.appeal"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="Сотовый телефон"
              :value="individual.tel"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="Email"
              :value="individual.email"
              :rules="rule_required"
            ></v-text-field>
          </div>

          <div
            v-if="accountType == 'entity'"
            style="border: 1 solid black !important"
          >
            <v-autocomplete
              v-model="entity"
              v-required
              label="ИНН"
              :loading="search.loading"
              :items="search.items"
              :search-input.sync="search.text"
              cache-items
              hide-no-data
              return-object
              auto-select-first
              item-text="inn"
              item-value="inn"
              :rules="rule_required"
              @input="onselect"
            >
              <template v-slot:selection="data">
                {{ data.item.inn }}
              </template>

              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name.short_with_opf }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span>
                      ИНН: <b>{{ item.inn }}</b
                      >, КПП <b>{{ item.kpp }}</b>
                      Дата регистрации:
                      <b>{{ orgRegisterDate(item.state.registration_date) }}</b>
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-text-field
              v-required
              label="ОГРН"
              :value="entity.ogrn"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="Полное наименование"
              :value="entity.name.full_with_opf"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="Краткое наименование"
              :value="entity.name.short_with_opf"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="БИК"
              :value="entity.bik"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="Расчётный счёт"
              :value="entity.account"
              :rules="rule_required"
            ></v-text-field>
            <v-text-field
              v-required
              label="КПП"
              :value="entity.kpp"
              :rules="rule_required"
            ></v-text-field>

            <br />
            <v-divider></v-divider>
            <br />

            <v-text-field
              v-required
              label="Адрес"
              :value="entity.address.value"
              :rules="rule_required"
            ></v-text-field>

            <br />
            <v-divider></v-divider>
            <br />

            <v-text-field
              v-required
              label="Рукводитель"
              :value="entity.management.name"
              :rules="rule_required"
            ></v-text-field>
          </div>

          <v-text-field
            v-required
            label="Капча"
            :value="capcha"
            :rules="rule_required"
          ></v-text-field>
        </v-card>
      </v-form>
    </container> -->
  </div>
</template>

<script>
import Container from "@/components/Container.vue";
import { Org, Auth, Search } from "@/api/common";

import { format } from "date-fns";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { create } from "vue-modal-dialogs";

import FieldSet from "@/components/ui/FieldSet.vue";
import PolygonEditor from "@/components/ui/PolygonEditor.vue";
import { Forms } from "@/api/dispatcher";

const polygonEditor = create(
  import(/* webpackChunkName: "dialogs" */ "@/components/ui/PolygonEditor.vue"),
  "points",
  "initLocation"
);

const Mode = {
  PhoneVerification: 1,
  Registration: 2,
};

export default {
  components: { Container, VueCountdown, FieldSet, PolygonEditor },
  data() {
    return {
      form: {
        valid: true,
        verify_valid: true,
        data: {},
        phone_verifyed: false,
        mode: Mode.PhoneVerification,
        timer: {
          counting: true,
        },
      },
      poly_svg: "",
      search: {
        // text: "",
        // loading: false,
        // items: [],
        area: {
          text: "",
          items: [],
          loading: false,
        },
        city: {
          text: "",
          items: [],
          loading: false,
        },
        street: {
          text: "",
          items: [],
          loading: false,
        },
        post: {
          text: "",
          items: [],
          loading: false,
        },
        inn: {
          loading: false,
        },
      },

      loading: false,

      accountTypes: {
        // f: "Физическое лицо",
        i: "Индивидуальный  предприниматель",
        u: "Юридическое лицо",
        // p: "Оператор вывоза мусора",
      },

      rule_required: [(v) => !!v || "Обязательное поле"],
      rule_email: [(v) => /.+@.+\..+/.test(v) || "Введён некорректный email"],

      step: 1,
      sms_code: "",
      accountType: "f",
      editable: false,

      user_data: {},
    };
  },
  computed: {
    formValid() {
      return (
        this.form.valid &&
        // this.form.phone_verifyed &&
        (this.form.data.points?.length || this.form.data.area_nmbr)
      );
    },
    buttonIcon() {
      if (this.mode == Mode.Registration) {
        return "mdi-lock";
      }

      return "mdi-phone";
    },
    buttonText() {
      if (this.accountType == "p") {
        return "Подать заявку";
      } else {
        if (this.mode == Mode.Registration) {
          return "Зарегистрироваться";
        } else {
          return "Подтвердить телефон";
        }
      }
    },
    orgRegisterDate() {
      return (d) => {
        return format(d, "dd.MM.yyyy");
      };
    },
    debug() {
      return process.env.NODE_ENV === "development";
    },
  },
  watch: {
    "search.text": function (text) {
      if (text && (text.length == 10 || text.length == 12)) {
        this.search_org(text);
      }
    },
    "search.area.text": function (text) {
      if (text) {
        this.get_area(text);
      }
    },
    "search.city.text": function (text) {
      if (text) {
        this.get_cities(text);
      }
    },
    "search.street.text": function (text) {
      if (this.form.data.city_nmbr && text) {
        this.get_streets(this.form.data.city_nmbr, text);
      }
    },
    "search.post.text": function (text) {
      if (text) {
        this.get_posts(text);
      }
    },
  },
  mounted() {
    // debug
    if (process.env.NODE_ENV === "development") {
      this.accountType = "p";
      this.form.data = {
        fam: "Иванов",
        name: "Иван",
        otc: "Иванович",
        mobile: "+79050820866",
        email: "druaga.qt@gmail.com",
      };

      this.form.data = {
        // controller:  "account",
        // task:        "reg_provider",
        name: "ООО Августина",
        short_name: "ООО Августина",
        inn: "",
        ogrn: "",
        kpp: "",
        city_nmbr: "",
        street_nmbr: "",
        house: "",
        flat: "",
        manager_post_nmbr: "",
        manager_fio: "",
        mobile: "",
        email: "egupov@rubtsovsk.ru",
      };

      this.user_data = {
        login: "91723",
        password: "57788",
      };
      // this.step = 4;
      this.step = 2;
      this.editable = true;
    }
  },
  methods: {
    prev() {
      if (this.step == 1) return;
      --this.step;
    },
    next() {
      if (this.step == 4) return;
      ++this.step;
    },
    async get_code(call_confirm) {
      let result;

      this.form.timer.counting = true;
      // wait till countdown really renders
      this.$nextTick(() => this.$refs.countdown.start());

      this.form.data.customer_type = this.accountType;
      this.form.data.crea_confirm_call = call_confirm;
      if (process.env.NODE_ENV === "development") {
        this.form.data.crea_confirm_call = "1"; // DEBUG
      }
      this.loading = true;
      try {
        let response;
        if (this.accountType == "u") {
          response = await Auth.register_provider(this.form.data);
        } else {
          response = await Auth.register_provider_ip(this.form.data);
        }
        if (response.status == "Ok") {
          this.user_data = response;
        } else {
          this.$root.$emit("server-error", response);
        }

        result = response.status == "Ok";
      } finally {
        this.loading = false;
      }

      return result;
    },
    async register() {
      if (this.get_code("1")) {
        this.next();
      }
    },
    async verify_phone() {
      this.loading = true;
      try {
        const response = await Auth.verify_provider(
          this.user_data.reg_id,
          this.sms_code
        );
        if (response.status == "Ok") {
          this.user_data = {
            ...this.user_data,
            ...response,
          };
          this.next();
        } else {
          this.$root.$emit("server-error", response);
        }
      } finally {
        this.loading = false;
      }
    },
    do_login() {
      Auth.login(this.user_data.login, this.user_data.password).then(
        (response) => {
          const { status, default_router } = response;
          if (status == "Ok") {
            this.$router.push(default_router ?? "/");
          } else {
            this.$root.$emit("server-error", response);
          }
        }
      );
    },
    search_org(inn) {
      let self = this;
      self.search.loading = true;
      Org.search(inn).then(function (org) {
        self.search.loading = false;
        self.search.items = [org];
      });
    },
    onselect() {
      console.log(this.search.org);
    },
    format,
    fillForm() {
      if (
        this.form.data.inn?.length == 10 ||
        this.form.data.inn?.length == 12
      ) {
        this.search.inn.loading = true;
        Org.get_provider_by_inn(this.form.data.inn)
          .then(({ fields }) => {
            Object.assign(this.form.data, fields);
            if (fields.city_nmbr) {
              this.search.city.items.push({
                nmbr: fields.city_nmbr,
                name: fields.city_name,
              });
              this.form.data.city_nmbr = fields.city_nmbr;
              this.setDefaultArea();
            }
            if (fields.street_nmbr) {
              this.search.street.items.push({
                nmbr: fields.street_nmbr,
                name: fields.street_name,
              });
              this.form.data.street_nmbr = fields.street_nmbr;
            }
            if (fields.manager_post_nmbr) {
              this.search.post.items.push({
                nmbr: fields.manager_post_nmbr,
                name: fields.manager_post_name,
              });
              this.form.data.manager_post_nmbr = fields.manager_post_nmbr;
            }
          })
          .finally(() => (this.search.inn.loading = false));
      }
    },
    get_area() {
      this.search.area.loading = true;
      Search.get_cities(this.search.area.text)
        .then((cities) => (this.search.area.items = cities.cities))
        .finally(() => (this.search.area.loading = false));
    },
    get_cities() {
      this.search.city.loading = true;
      Search.get_cities(this.search.city.text)
        .then((cities) => (this.search.city.items = cities.cities))
        .finally(() => (this.search.city.loading = false));
    },
    get_streets() {
      this.search.street.loading = true;
      Search.get_streets(this.form.data.city_nmbr, this.search.street.text)
        .then((streets) => (this.search.street.items = streets.streets))
        .finally(() => (this.search.street.loading = false));
    },
    get_posts() {
      this.search.post.loading = true;
      Search.get_posts(this.search.post.text)
        .then((posts) => (this.search.post.items = posts.posts))
        .finally(() => (this.search.post.loading = false));
    },
    async editPolygon() {
      console.log(this.search.area.text);
      const points = await polygonEditor(
        this.form.data.points ?? [],
        this.search.area.text
      );
      console.log(points);

      if (points) {
        Forms.get_terr_svg_polygon(points).then(
          (response) => (this.poly_svg = response.svg)
        );
        // this.form.data.points = points;
        this.$set(this.form.data, "points", points);
      }
    },
    setDefaultArea() {
      if (!this.form.data.area_nmbr) {
        this.search.area.items = this.search.city.items;
        this.form.data.area_nmbr = this.form.data.city_nmbr;
      }
    },
  },
};
</script>
